/**
 * URL工具函数
 */

/**
 * 处理文件URL，将IP地址替换为正确的域名
 * @param {string} url - 原始URL
 * @returns {string|null} - 处理后的URL
 */
export const processFileUrl = (url) => {
  if (!url) return null;
  
  // 将IP地址的HTTP/HTTPS链接替换为正确的HTTPS域名
  return url
    .replace(/http:\/\/139\.224\.186\.29:8000\/files\//, 'https://aitui.co/files/')
    .replace(/https:\/\/139\.224\.186\.29:8000\/files\//, 'https://aitui.co/files/');
};

/**
 * 处理头像URL（processFileUrl的别名）
 * @param {string} avatarUrl - 头像URL
 * @returns {string|null} - 处理后的头像URL
 */
export const processAvatarUrl = processFileUrl; 